import styled from 'styled-components'

export const Container = styled.div``

export const Charts = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`
